import { ACTION_TYPES } from '../../constants/actionsTypes';
import { USER_STATUS } from '../../constants/userStatus';

export const handleUserManagementCardActions = (
  actionType: string,
  setIsCreateUser?: (value: boolean) => void,
  handleStatusUsersView?: (
    value: (typeof USER_STATUS)[keyof typeof USER_STATUS]
  ) => void
) => {
  if (actionType === ACTION_TYPES.ACTIVE_USERS) {
    // Show active users
    if (handleStatusUsersView) {
      handleStatusUsersView(USER_STATUS.ACTIVE);
    }
  }

  if (actionType === ACTION_TYPES.CREATE_USER) {
    if (setIsCreateUser) {
      setIsCreateUser(true);
    }
  }

  if (actionType === ACTION_TYPES.DELETED_USERS) {
    // Show deleted users
    if (handleStatusUsersView) {
      handleStatusUsersView(USER_STATUS.DELETED);
    }
  }
};
